import { Link } from '@tanstack/react-router';
import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/**
 * קישור לקונסולה בסרגל הצד — רק למפעילי פלטפורמה (session.isPlatformAdmin).
 * אותו עיצוב כמו פריטי הניווט ב-AppShell, מופרד בקו.
 */
export function AdminNavLink({
  pathname,
  onNavigate,
}: {
  pathname: string;
  onNavigate?: () => void;
}) {
  const { t } = useTranslation('admin');
  const active = pathname.startsWith('/admin');
  return (
    <div className="mt-2 border-t border-nav-border pt-2">
      <Link
        to="/admin"
        onClick={onNavigate}
        data-track="nav.admin"
        aria-current={active ? 'page' : undefined}
        className={cn(
          'relative flex items-center gap-3 rounded-(--radius-md) px-3 py-2.5 text-sm transition-colors duration-(--duration-fast)',
          'focus-visible:outline-accent-bright',
          active
            ? 'bg-nav-active font-semibold text-nav-active-fg shadow-sm'
            : 'text-nav-fg-muted hover:bg-nav-hover hover:text-nav-fg',
        )}
      >
        {active ? (
          <span
            className="absolute inset-y-2 -start-3 w-1 rounded-e-full bg-accent-bright"
            aria-hidden
          />
        ) : null}
        <ShieldCheck
          className={cn('size-4 shrink-0', !active && 'text-nav-fg-muted')}
          aria-hidden
        />
        {t('nav.link')}
      </Link>
    </div>
  );
}
